import React, { useEffect, useState } from "react";

import { Box, BoxProps, Fade, makeStyles } from "@material-ui/core";
import classNames from "classnames";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: "rgba(18, 78, 93, 1)",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    justifyItems: "center",
    minHeight: "100vh",
    [theme.breakpoints.down("sm")]: {
      padding: "0px",
      paddingTop: "10px",
      paddingBottom: "60px",
    },
  },
  image: {
    [theme.breakpoints.down("sm")]: {
      width: "20vw",
    },
  },
  details: {
    [theme.breakpoints.down("sm")]: {
      alignContent: "center",
      alignItems: "center",
      textAlign: "center",
    },
    rowGap: "8px",
    color: "white",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
  },
  productsImage: () => ({
    [theme.breakpoints.down("sm")]: {
      width: "calc(100vw - 80px)",
    },
  }),
}));

interface ISideBanner extends BoxProps {
  disabledSlideShow?: boolean;
  timeout?: number;
  endAdornement?: React.ReactNode;
  startAdornement?: React.ReactNode;
}
function SideBanner({
  children,
  timeout,
  disabledSlideShow,
  startAdornement,
  endAdornement,
  ...rest
}: ISideBanner) {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(1);
  const maxIndex = _.size(children || []);
  const minIndex = 1;

  useEffect(() => {
    if (disabledSlideShow) {
      return;
    }
    const interval = setInterval(() => {
      if (currentIndex === maxIndex) {
        setCurrentIndex(minIndex);
      } else {
        setCurrentIndex(currentIndex + 1);
      }
    }, 4000);
    return () => {
      clearInterval(interval);
    };
  });

  return (
    <Box
      className={classNames(classes.container, rest.className)}
      {..._.omit(rest, "className")}
      overflow={"hidden"}
    >
      <Box className={classes.details} position={"relative"}>
        <Box>{startAdornement}</Box>
        <Box>
          {React.Children.map(children, (child, index) => (
            <Fade in={currentIndex === index + 1} timeout={timeout ?? 1500}>
              <Box style={{ position: "absolute" }}>{child}</Box>
            </Fade>
          ))}
        </Box>

        <Box>{endAdornement}</Box>
      </Box>
    </Box>
  );
}

export default SideBanner;
